export default __webpack_public_path__ + "static/media/google.9a61aa1f.png";